import { Heading, Inline, Stack } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { headingStyles, inlineWrapper, travelerButtonDesktop, travelerButtonDesktopScrollable, travelerDesktopContainer } from '../utils/styles';
import SingleTravelerButton from './SingleTravelerButton';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SeatMapTravelersDesktop = _ref => {
  let {
    activeSeatAssignments,
    activeSegment,
    activeTraveler,
    isRyanairInTrip,
    onChange,
    onRemoveSeat,
    seatTravelers,
    setTravelerButtonWithRemoveLink,
    travelerButtonWithRemoveLink
  } = _ref;
  const {
    t
  } = useTranslation();
  const passengerInformationHeading = t('Product.SeatMap.Passenger.Information.Header.Label');
  const isSingleTraveler = seatTravelers.length === 1;
  return /*#__PURE__*/_jsxs(Stack, {
    className: travelerDesktopContainer,
    "data-testid": "seatMap-travelers",
    children: [/*#__PURE__*/_jsx(Heading, {
      className: headingStyles,
      level: 3,
      children: passengerInformationHeading
    }), /*#__PURE__*/_jsx(Inline, {
      className: inlineWrapper,
      children: /*#__PURE__*/_jsx(Stack, {
        className: seatTravelers.length > 5 ? `${travelerButtonDesktop} ${travelerButtonDesktopScrollable}` : travelerButtonDesktop,
        children: seatTravelers.map(traveler => /*#__PURE__*/_jsx(SingleTravelerButton, {
          activeSeatAssignments: activeSeatAssignments,
          activeSegment: activeSegment,
          activeTraveler: activeTraveler,
          isRyanairInTrip: isRyanairInTrip,
          isSingleTraveler: isSingleTraveler,
          onChange: onChange,
          onRemoveSeat: onRemoveSeat,
          setTravelerButtonWithRemoveLink: setTravelerButtonWithRemoveLink,
          traveler: traveler,
          travelerButtonWithRemoveLink: travelerButtonWithRemoveLink
        }, traveler.id))
      })
    })]
  });
};
export default SeatMapTravelersDesktop;
//# sourceMappingURL=SeatMapTravelersDesktop.js.map